/**
 * Shared constants for SpotHitch
 */

export const ADMIN_EMAILS = ['antoine.v.ville@gmail.com', 'ci-admin@spothitch.com']
